var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEyeIconAllowed(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "11px",
    viewBox: "0 0 16 11",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "eye-icon__allowed") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "IBM-Runbooks",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    transform: "translate(-534.000000, -278.000000)",
    fill: "#F3F3F3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "eye-icon__allowed",
    transform: "translate(534.000000, 278.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8,7.5 C9.1045695,7.5 10,6.6045695 10,5.5 C10,4.3954305 9.1045695,3.5 8,3.5 C6.8954305,3.5 6,4.3954305 6,5.5 C6,6.6045695 6.8954305,7.5 8,7.5 Z M15.47,5.33 C14.2680152,2.22085062 11.3310488,0.12526414 8,0 C4.6689512,0.12526414 1.73198477,2.22085062 0.53,5.33 C0.490283624,5.4398538 0.490283624,5.5601462 0.53,5.67 C1.73198477,8.7791494 4.6689512,10.8747359 8,11 C11.3310488,10.8747359 14.2680152,8.7791494 15.47,5.67 C15.5097164,5.5601462 15.5097164,5.4398538 15.47,5.33 Z M8,8.75 C6.20507456,8.75 4.75,7.29492544 4.75,5.5 C4.75,3.70507456 6.20507456,2.25 8,2.25 C9.79492544,2.25 11.25,3.70507456 11.25,5.5 C11.2472467,7.29378374 9.79378374,8.7472467 8,8.75 Z",
    id: "Fill"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeIconAllowed);
export default __webpack_public_path__ + "static/media/eye-icon__allowed.c00974d6c2e1eda8006dc02595c72313.svg";
export { ForwardRef as ReactComponent };